import type { Asset, Device } from './assetsApi';

export const relevantDeviceTypes = ['man-webfleet', 'ocu3', 'tbm2', 'tbm3', 'vcm', 'cm4'] as const;
export type RelevantDeviceType = (typeof relevantDeviceTypes)[number];

export const isRelevantDevice = (device: Device): boolean =>
    relevantDeviceTypes.includes(device.type as RelevantDeviceType);

export const removeDuplicatesById = (arr: Asset[]): Asset[] => {
    const uniqueMap = new Map<string, Asset>();
    arr.forEach(item => {
        if (!uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
        }
    });
    return Array.from(uniqueMap.values());
};
